<script>
  export let height = 12
  export let width = 12
</script>

<svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 12 12">
  <path fill="#D83B41" fill-rule="evenodd" d="M6 0C2.7 0 0 2.7 0 6C0 9.3 2.7 12 6 12C9.3 12 12 9.3 12 6C12 2.7 9.3 0 6 0ZM4.93112 6L3 7.93112L4.06888 9L6 7.06888L7.93112 9L8.99888 7.93112L7.06832 6.00056L9 4.06888L7.93112 3L5.99944 4.93168L4.06776 3L3 4.06888L4.93112 6Z" clip-rule="evenodd" />
</svg>
